import { css } from "styled-components";
import { typography } from "./fonts";

// Type-only defaults. Height and border-radius deliberately live on the field
// components instead: this rule is ID-scoped, so anything it declares outranks
// every styled-component class and silently overrides them.
const themeInputs = css`
  #root {
    input[type="email"],
    input[type="password"],
    input[type="text"],
    input[type="date"] {
      ${typography.body1}
      font-size: 14px;
      line-height: 17px;
    }
  }
`;

export default themeInputs;
